import { render } from "./LightButton.vue?vue&type=template&id=68b721f6&scoped=true"
import script from "./LightButton.vue?vue&type=script&lang=js"
export * from "./LightButton.vue?vue&type=script&lang=js"

import "./LightButton.vue?vue&type=style&index=0&id=68b721f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b721f6"]])

export default __exports__